module.exports = __webpack_public_path__ + "img/icon_Space_B.2bd23f86.svg";